<div class="component-wrapper">
    <div class="resource-container documents" [ngClass]="{'active':isOpened}" data-collapsed="true" style="height:0px;" *ngIf="type==='resources'">
        <div class="resource-container-wrapper" [ngClass]="{'toyota':appName==='toyota','lexus':appName==='lexus'}">
            <div class="row">
                <div class="col-sm-4" *ngFor="let key of Group;let i =index;">
                    <div class="section-wrapper" [ngClass]="{'last':(i + 1) % 3 == 0 || Group.length - 1 == i}">
                        <h3 class="section-title"> {{key}} </h3>
                        <div class="section-content">
                            <ul *ngIf="content && content.length">
                                <li *ngFor="let doc of content">
                                    <a *ngIf="key == doc.resources.resourceGroup" (click)="openFileInNewTab($event,doc.resources.resourceUrl)" rel="noopener" target="_blank"
                                        href="{{doc.resources.resourceUrl}}">{{doc.resources.resourceName}}</a>

                                    <span class="new-resource" *ngIf="doc.resources.isNewResource && key == doc.resources.resourceGroup && calculateDateDiff(doc.uploadedTime)">
                                        New</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="resource-container videos" [ngClass]="{'active':isOpened}" data-collapsed="true" style="height:0px;" *ngIf="type==='videos'">
        <div class="resource-container-wrapper">
            <div class="row justify-content-center">
                <div class="col-sm-6" *ngFor="let key of Group;let i =index;">
                    <div class="section-wrapper" [ngClass]="{'last':(i + 1) % 3 == 0 || Group.length - 1 == i}">
                        <h3 class="section-title"> {{key}} </h3>
                        <div class="section-content">
                            <ul *ngIf="content && content.length">
                                <li *ngFor="let doc of content">
                                    <!-- <a *ngIf="key == doc.videoGroup" (click)="openFileInNewTab($event,doc.videoUrl)" target="_blank" href="{{doc.videoUrl}}">{{doc.videoName}}</a> -->
                                    <a *ngIf="key == doc.videoGroup" (click)="openDialog(doc.videoUrl)">{{doc.videoName}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>